import { ShoppingCart, Menu, Phone } from 'lucide-react'
import { Button } from './ui/button'
import { Badge } from './ui/badge'

interface HeaderProps {
  cartItemCount: number
  onCartClick: () => void
}

export function Header({ cartItemCount, onCartClick }: HeaderProps) {
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img className="t454__imglogo t454__imglogomobile" src="https://intershina.pro/images/logo_intershinna.png"  alt=""/>        
          </div>

          {/* Navigation - Desktop */}
          <nav className="hidden md:flex space-x-8">
            <a href="/" className="text-gray-900 hover:text-[#ed8510] px-3 py-2 rounded-md transition-colors">
              Шины
            </a>
            <a href="/about" className="text-gray-900 hover:text-[#ed8510] px-3 py-2 rounded-md transition-colors">
              О нас
            </a>
            <a href="#contact" className="text-gray-900 hover:text-[#ed8510] px-3 py-2 rounded-md transition-colors">
              Контакты
            </a>
          </nav>

          {/* Right side - Phone and Cart */}
          <div className="flex items-center space-x-4">
            <div className="hidden sm:flex items-center space-x-2 text-gray-600">
              <Phone className="h-4 w-4" />
              <span>+7(812)985-13-11</span>
            </div>
            
            <Button 
              variant="outline" 
              size="sm" 
              onClick={onCartClick}
              className="relative hover:border-[#ed8510] hover:text-[#ed8510]"
            >
              <ShoppingCart className="h-4 w-4" />
              {cartItemCount > 0 && (
                <Badge 
                  className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 text-xs bg-[#ed8510] text-white hover:bg-[#d97009]"
                >
                  {cartItemCount}
                </Badge>
              )}
            </Button>

            {/* Mobile menu button */}
            <Button variant="ghost" size="sm" className="md:hidden">
              <Menu className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </header>
  )
}